export default {
  scheduleClasses: (state) => {
    return state.allClasses.filter((classObject) => !!classObject).sort((a, b) => {
      const result = a.teacher.firstName < b.teacher.firstName ? -1 : a.teacher.firstName > b.teacher.firstName ? 1 : 0
      return result * -1
    })
  }
}
